import "babel-polyfill";

import PageController from './Controller/PageController';

$('[data-equalizer]').on('postequalized.zf.equalizer', function() {
    $(this).addClass('equalized');
});

// initialise foundation js
$(document).foundation();

$(document).ready(function() {
    // pass ready event to the PageController
    PageController.onReady();

    // initialise fancybox links
    $('a[class*=fancybox],a[class*=lightbox],a[rel*=fancybox]').fancybox({
            live: false
        }
    );

    $('.form-more-fields').css('display', 'none');
    $('.form-show-more-fields').on('click', function() {
        $('.form-more-fields').slideDown(300);
        $(this).remove();
    });
});